<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码" class="itemcode">
              <a-input-group compact>
                <a-input v-model="queryParams.itemCode" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="规格描述">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="主要单位">
              <global-select
                :value.sync="queryParams.primaryUomCode"
                selectType="selectMultiple"
                requestApi="/mdm/mdmUomUnitsOfMeasure/unitOfMeasureList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料类型">
              <global-select
                :value.sync="queryParams.itemType"
                selectType="selectMultiple"
                :selectData="itemTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料状态">
              <!-- <global-select
                :value.sync="queryParams.itemStatusCode"
                selectType="select"
                :selectData="validList"
                :selectItem="{ value: 'key', label: 'value' }"
              /> -->

              <global-select
                :value.sync="queryParams.itemStatusCode"
                selectType="select"
                requestApi="/mdm/mdmItemOrganizationItem/findItemStatusList"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="供应商">
              <global-select
                :value.sync="queryParams.vendorName"
                selectType="selectMultipleSearch"
                requestApi="/mdm/mdmOrgSupplier/supplierNameList"
                :selectItem="{ value: 'realValue', label: 'realValue' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="生效BOM">
              <a-switch v-model="queryParams.effectiveFlag" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="研发BOM">
              <a-switch v-model="queryParams.bomType" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemInventoryNewExport" ref="download" />
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:itemInventory:export']">导出</a-button>
      <a-button @click="handleSynchronous" type="primary" :loading="btnLoading" v-hasPermi="['mdm:itemInventory:synchronous']">下载签价BOM</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          :pagination="false"
          row-key="id"
        >
          <template slot="itemCode" slot-scope="text, record">
            <router-link :to="`/materialInventory/detail/${record.id}/${record.itemCode}/${record.description}/${record.alternateBom}`">
              <span>{{ text }}</span>
            </router-link>
          </template>
          <template slot="itemStatusCode" slot-scope="text">
            <span>{{ text === "Y" ? "有效" : "无效" }}</span>
          </template>
        </a-table> -->
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1800 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MATERIAL_INVENTORY_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="itemCode" slot-scope="{ text, record }">
            <a @click="handleDetail(record)">{{ text }}</a>
          </template>
          <template slot="itemStatusCode" slot-scope="{ text }">
            <span>{{ text === "Y" ? "有效" : "无效" }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import deepClone from "lodash.clonedeep";
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js';
import {
  apiItemInventoryList,
  apiMdmGetSignBom,
  apiMdmItemInventoryNewExport
} from '@/api/mdm/matter/material-inventory'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'MaterialInventory',
  components: { DownloadModal },
  data () {
    return {
       apiMdmItemInventoryNewExport,
      btnLoading: false, // 按钮loading
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiItemInventoryList, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: false,
        pageUrl: '/mdm/itemInventory/list',
        tableLoading: false
      },
      isEdit: false,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationId: undefined,
        itemCodeStart: undefined,
        itemCodeEnd: undefined,
        description: undefined,
        effectiveFlag: true,
        bomType: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          width: 150,
          dataIndex: 'organizationName',
          stickyFixed: 'left',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          stickyFixed: 'left',
          width: 150,
          scopedSlots: { customRender: 'itemCode' },
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '签价单号',
          dataIndex: 'alternateBom',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '版本',
          dataIndex: 'bomVersion',
          width: 100,
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'vendorName',
          ellipsis: true,
          width: 230,
          align: 'center'
        },
        {
          title: '供应商编码',
          dataIndex: 'vendorCode',
          align: 'center',
          width: 150
        },
        {
          title: '生效时间',
          dataIndex: 'startDate',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '失效时间',
          dataIndex: 'endDate',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '采购模式',
          dataIndex: 'procurementModel',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '替代项说明',
        //   dataIndex: 'alternateBomDesc',
        //   align: 'center'
        // },
        {
          title: '主要单位',
          dataIndex: 'primaryUomCode',
          width: 100,
          align: 'center'
        },
        {
          title: '物料类型',
          dataIndex: 'itemType',
          width: 150,
          align: 'center'
        },
        {
          title: '物料状态',
          dataIndex: 'itemStatusCode',
          width: 100,
          align: 'center'
        }
      ],
      validList: [
        {
          key: "Y",
          value: "有效"
        },
        {
          key: "N",
          value: "无效"
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      itemTypeList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getLookupList('MDM_ITEM_TYPE', 'itemTypeList')
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    // 触发定时任务“签价BOM同步”
    handleSynchronous() {
      this.btnLoading = true
      apiMdmGetSignBom({}).then(res => {
        if (res?.code === 200) {
          this.$message.success(res?.data || '操作成功')
          this.onSearch()
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    handleDetail (record) {
      this.$router.push({ name: `material-inventory-detail`, query: { id: record.id, itemCode: record.itemCode, description: record.description, alternateBom: record.alternateBom } })
    },
    // 表单搜索
    onSearch () {
      const tempParms = deepClone(this.queryParams)
      tempParms.organizationId = this.organizationCodeOrigin
      tempParms.effectiveFlag = tempParms.effectiveFlag ? "Y" : "N"
      tempParms.bomType = tempParms.bomType ? "Y" : "N"
      this.$refs.dataTable.searchParams = tempParms;
      this.$refs.dataTable.getData();
    },
    itemCodeStartChange (val) {
      this.queryParams.itemCodeStart = val
      if (!this.queryParams.itemCodeEnd) {
        this.queryParams.itemCodeEnd = val
      }
    },
    itemCodeEndChange (val) {
      this.queryParams.itemCodeEnd = val
      if (!this.queryParams.itemCodeStart) {
        this.queryParams.itemCodeStart = val
      }
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download('mdm/itemInventory/export', {
      //   ...this.queryParams
      // }, `物料清单_${new Date().getTime()}.xlsx`)
    },
    /** 查询快码类型列表 */
    getList (data) {
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationId: undefined,
        itemCodeStart: undefined,
        itemCodeEnd: undefined,
        description: undefined,
        effectiveFlag: 'Y',
        bomType: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.itemcode{
  /deep/.ant-select{
    display: unset;
  }
  /deep/.ant-input-group.ant-input-group-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-code-select {
    // width: 48% !important;
    flex: 1;
  }
  .item-code-select-separator {
    margin: 0 5px;
  }
}
</style>
